import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import { InsurerProgressItem } from "src/app/share/constants/quotation-progress";

@Component({
  selector: "app-progress-chip",
  templateUrl: "./progress-chip.component.html",
  styleUrls: ["./progress-chip.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressChipComponent {
  @Input() item: InsurerProgressItem;
  @Output() chipClick = new EventEmitter<string>();
}
